import { Box, Button, Container, FormControl, Paper, TextField, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { borderRadius, maxWidth } from "@mui/system";
import { AuthContext } from "components/authProvider/authProvider";
import { host } from "config";
import { useContext, useState } from "react";

const OptiIntelligenceDashboard: React.FC = () => {
  const [formData, setFormData] = useState({ email: "" });
  const authContext = useContext(AuthContext);
  if (!authContext) {
    throw new Error("AuthContext is undefined");
  }
  const { currentUser, selectedGroup, role, dataStudioEmail, dataStudioLink } = authContext;

  function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  }

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    currentUser.getIdToken(false).then((tk) => {
      fetch(`${host}/api/firebase/api/requestDataStudioReport`, {
        method: "POST",
        body: JSON.stringify(formData),
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${tk}`,
        },
      }).then((resp) => {
        if (resp.ok) {
          alert("Your request has been successfully submitted.");
          window.location.reload();
        } else {
          alert(
            "There was an issue while trying to submit your request. Please try again later or contact IT if the problem persists."
          );
        }
      });
    });
  }

  return (
    <div>
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            backgroundColor: "#ffffff",
            borderRadius: 2,
            border: "2px solid #000",
            boxShadow: "none",
          }}
        >
          <Typography variant="h2" textAlign={"center"} paddingBottom={4}>
            Opti Intelligence Dashboard
          </Typography>
          {!dataStudioEmail ? (
            <>
              <Box
                sx={{
                  backgroundColor: "rgba(220, 10, 40, .33)",
                  border: "2px solid rgb(220, 10, 40)",
                  borderRadius: 2,
                  padding: 2,
                  marginBottom: 2,
                }}
              >
                <Typography variant="body1">
                  Welcome to your Opti Intelligence Dashboard. We utilize Google's intelligence reporting platform. To
                  access the report, you will need to enter your gmail address. Once entered, your Gmail account will be
                  linked to the report providing you access in the future without any further access requirements. If
                  you do not have a gmail account, please create an account by selecting the Create Account button below
                  or contacting us at oisupport@carynhealthms.com. For any questions about the dashboard information and
                  data, or you would like to request additional materials added to the dashboard, please contact your
                  account manager.
                </Typography>
              </Box>
              <Box component="form" onSubmit={handleSubmit}>
                <TextField label="Google Email" name="email" value={formData.email} onChange={handleChange}></TextField>
                <Button
                  type="submit"
                  variant="contained"
                  sx={{ backgroundColor: "#004e9d", color: "#ffffff", ":hover": { backgroundColor: "#004e9d" } }}
                >
                  Submit
                </Button>
                <Button
                  href="https://accounts.google.com/signupwithoutgmail"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    alignSelf: "center",
                    backgroundColor: "#ff8c00",
                    color: "#ffffff",
                    ":hover": { backgroundColor: "#ff8c00", color: "#ffffff" },
                  }}
                  variant="contained"
                >
                  Create Account
                </Button>
              </Box>
            </>
          ) : !dataStudioLink || dataStudioLink.trim() === "" ? (
            <Box
              sx={{
                backgroundColor: "rgba(255, 165, 0, .33)",
                border: "2px solid rgb(255, 165, 0)",
                borderRadius: 2,
                padding: 2,
                marginBottom: 2,
              }}
            >
              <Typography variant="body1">
                Your Google email has been successfully and submitted and is currently being processed. You should
                receive an email link with an invitation to the report when this request has been processed. Please
                contact our Customer Support team if this has not been processed within two business days of your email
                being submitted.
              </Typography>
            </Box>
          ) : (
            <>
              <Box
                sx={{
                  backgroundColor: "rgba(0, 200, 0, .33)",
                  border: "2px solid rgb(0, 200, 0)",
                  borderRadius: 2,
                  padding: 2,
                  marginBottom: 4,
                }}
              >
                <Typography variant="body1">
                  The link to your Opti Intelligence Dashboard is below. Please follow this link and sign into your
                  Google email.
                </Typography>
              </Box>
              <Box textAlign={"center"}>
                <Button
                  href={dataStudioLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ alignSelf: "center" }}
                  variant="contained"
                >
                  Opti Intelligence Dashboard
                </Button>
              </Box>
            </>
          )}
        </Paper>
      </Container>
    </div>
  );
};

export default OptiIntelligenceDashboard;
